// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"117":"6071c1675c0f4be9","766":"66fd8cee1b485dac","7737":"128eb725a66f9fe7","8436":"fa493fdbc1b49520"}[chunkId] + ".css";
};